import { useRoute } from 'nuxt/app'
import { TPageRequestOptions } from '~/types/page-types'
import { pageDefinitions } from '~/constants/pages'
import { getPage } from '~/services/custom-endpoints'

// this is where we load the page data based on props.collection and an optional filter
export const useLoadPage = async (collection: string, filter?: object, preview: boolean | undefined = false, secret: string | undefined = undefined) => {
  const route = useRoute()

  const requestOptions: TPageRequestOptions = { collection, ...pageDefinitions[collection] } as TPageRequestOptions

  if (preview) {
    if (!filter) {
      filter = {}
    }

    // if we're previewing, remove the 'published' status filter if it has been set
    if (filter.status) {
      delete filter.status
    }

    // add the secret for matching
    filter.secret = secret
  }

  if (filter) {
    requestOptions.filter = JSON.stringify(filter)
  }

  if (!requestOptions.singleton) {
    // parse the uri
    requestOptions.uri = route.path.endsWith('/') ? route.path.slice(0, -1) : route.path
  }
  const { data, pending, error } = await getPage(requestOptions)
  return { data, pending, error }
}
